import * as angular from 'angular';
import * as moment from 'moment';

import {
  OnInit,
  Component,
  Input,
  Inject
} from 'ng-metadata/core';

import currencyHtml from './currency.html';
import './currency.scss'
import { CurrencyService } from 'services/currency.service';

@Component({
  selector: 'gwCurrency',
  template: currencyHtml,
})
export class CurrencyComponent implements OnInit {
  @Input() country

  public rate: number;
  public base_amount: number = 1;
  public to_amount: number;
  public base: any;
  public to: any;

  public labels;
  public data = [];
  public colors = ['#ff6384'];
  public options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        ticks: {
            autoSkip: true,
            maxTicksLimit: 6,
            maxRotation: 0
        }
    }]
    }

  }

  constructor(
    @Inject('$filter') private $filter,
    @Inject(CurrencyService) private currencyService: CurrencyService 
  ) {}
  
  async ngOnInit() {
    await this.getRate()
    this.calculate('base');
    this.getHistory();
  }

  async getRate() {
    try {
      let response = await this.currencyService
        .getRate('US', this.country);

      this.rate = response.rate;
      this.base = response.base;
      this.to = response.to;
    } catch(e) {
      throw e;
    }
  }

  async getHistory() {
    try {
      let response = await this.currencyService
        .getCurrencyHistory('US', this.country);

      this.labels = Object.keys(response.rates).map( key => moment(key, "YYYY-MM-DD").format("MMM, DD"))
      this.data.push(Object.values(response.rates))
    } catch(e) {
      throw e;
    }
  }

  calculate(unit: string) {
    if (unit == 'base') {
      this.to_amount = Math.round(this.rate * this.base_amount*100)/100;
    } else {
      this.base_amount = Math.round(this.to_amount/this.rate*100)/100;
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/currency/currency.component.ts